import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectUserActiveEmployerBusinessId } from 'store/user/selectors.js/user.selectors';
import { postGetResourcesByProjectBusinessId } from '../services/getResourcesByProjectBusinessId.service';

export const loadResourcesThatHaveJoinedProjectsOfBusiness = createAsyncThunk(
  'resources/loadResourcesThatHaveJoinedProjectsOfBusiness',
  async ({ businessId, filterEmployerBusinessIds = [] }, { getState }) => {
    const activeEmployerBusinessId =
      selectUserActiveEmployerBusinessId(getState());

    const effectiveProjectBusinessId = businessId
      ? businessId
      : activeEmployerBusinessId;

    const response = await postGetResourcesByProjectBusinessId(
      effectiveProjectBusinessId,
      filterEmployerBusinessIds
    );

    return response;
  }
);
